// Por quanto tempo cada tipo de dado pode ficar "fresco" no cache.
//
// Existe para reduzir LEITURA do Firestore, que é a maior linha da fatura do
// projeto. O padrão do react-query era 5 minutos para tudo: numa sessão de meia
// hora, o aluno relia tema, imagens da marca e a lista inteira de categorias
// (1 leitura da coleção + 1 por categoria) meia dúzia de vezes, sem nada ter
// mudado no meio.
//
// O corte é por VOLATILIDADE, não por tela:
//
// - BRAND: cores, fontes, textos e imagens da marca. Só mudam quando o admin
//   edita — e toda mutação de marca já invalida a sua query (ver api/Brand),
//   então quem edita continua vendo o resultado na hora.
// - CONTENT: categorias e cards. Mudam quando o admin publica conteúdo; o
//   painel invalida via `refreshCategories()`. Para o aluno que já está com o
//   app aberto, conteúdo novo aparece na próxima janela — ou imediatamente, se
//   ele recarregar a página.
//
// O que NÃO está aqui é de propósito: dados de acesso do aluno (userQuery)
// seguem com o padrão curto, porque uma compra recém-liberada precisa aparecer.

export const CACHE_TIME = {
  // Marca e configurações que quase nunca mudam.
  BRAND: 1000 * 60 * 60, // 1 hora
  // Conteúdo publicado pelo admin.
  CONTENT: 1000 * 60 * 15, // 15 minutos
};

// Quanto tempo o dado sobrevive no cache DEPOIS que ninguém mais o usa.
//
// Sem isto o `staleTime` acima renderia pouco: o padrão do react-query descarta
// o cache 5 minutos após a última tela que o usava sair do ar, então voltar
// para a home depois de cinco minutos relia tudo de novo, "fresco" ou não.
// É só memória do navegador — nenhum custo de leitura.
export const GC_TIME = 1000 * 60 * 60; // 1 hora
